var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReloadIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5 0.5C7.66499 0.5 5.20626 1.54124 3.12375 3.62375L9.53674e-07 0.5V8.375H7.875L5.01375 5.51375C6.57126 3.92124 8.39999 3.125 10.5 3.125C12.67 3.125 14.525 3.89499 16.065 5.435C17.605 6.97501 18.375 8.82999 18.375 11C18.375 13.17 17.605 15.025 16.065 16.565C14.525 18.105 12.67 18.875 10.5 18.875C8.32999 18.875 6.47501 18.105 4.935 16.565L3.045 18.455C5.07501 20.485 7.55999 21.5 10.5 21.5C13.3875 21.5 15.8594 20.4719 17.9156 18.4156C19.9719 16.3594 21 13.8875 21 11C21 8.11248 19.9719 5.64063 17.9156 3.58437C15.8594 1.52811 13.3875 0.5 10.5 0.5Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    fill: "white",
    transform: "matrix(-1 0 0 1 21 0.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReloadIcon);
export default __webpack_public_path__ + "static/media/reloadIcon.37f23d44e58fd46858b24f1ced56b3c8.svg";
export { ForwardRef as ReactComponent };